export const authors = {
  'giovanni-vaccaro': {
    name: 'Giovanni Vaccaro',
    slug: 'giovanni-vaccaro',
    title: 'Co-Founder & Chief Brand Officer',
    expertise: 'Beauty & Wellness',
    education: 'Capri School of Hair Design',
    educationUrl: 'https://www.caprinow.edu/',
    degree: 'Cosmetology',
    headshot: '/authors/giovanni-vaccaro.jpg',
    instagram: 'https://www.instagram.com/giovannivaccaro/',
    linkedin: 'https://www.linkedin.com/in/giovanni-vaccaro-b4137a90/',
    website: 'https://www.giovaccaro.com/',
    metaDescription:
      'Meet Giovanni Vaccaro, Co-Founder and Chief Brand Officer of GLAMSQUAD, bringing 22+ years of salon expertise to on-demand, in-home beauty services.',
    shortBio:
      'Giovanni Vaccaro is the Co-Founder and Chief Brand Officer of GLAMSQUAD. With over 22 years in the beauty industry, Gio co-founded GLAMSQUAD in 2014 to bring salon-quality beauty services to clients in the comfort of their own homes.',
    fullBio: `Giovanni Vaccaro is the Co-Founder and Chief Brand Officer of GLAMSQUAD, the leading on-demand beauty services platform. With over 22 years in the beauty industry, Gio began his career at Frederic Fekkai, one of New York's most prestigious luxury salons, where he spent a decade as a Senior Stylist and Brand Ambassador.

Inspired by clients who wanted salon-quality beauty in the comfort of their own homes, he co-founded GLAMSQUAD in 2014. Under his leadership, the company has grown to serve 15+ cities nationwide with a community of over 2,000 beauty professionals, completing more than one million services.

Gio's work has been featured in Vogue, Cosmopolitan, Elle, The Wall Street Journal, and InStyle, and he has appeared on Good Morning America, The Today Show, and Access Hollywood. A passionate advocate for the transformative power of beauty, Gio believes that confidence starts with how you feel — and how you look is part of that equation.`,
    highlights: [
      'Co-Founder & Chief Brand Officer of GLAMSQUAD',
      '22+ years in the beauty industry',
      'Former Senior Stylist & Brand Ambassador at Frederic Fekkai',
      'Over 1,000,000 services completed through GLAMSQUAD',
      'Featured in Vogue, Cosmopolitan, Elle, The Wall Street Journal, and InStyle',
    ],
    experience: `Gio left his family's restaurant business at age 18 to attend cosmetology school. He went on to spend a decade at Frederic Fekkai, one of New York's premier luxury salons, where he rose to Senior Stylist and Brand Ambassador.

When clients began asking him to bring the salon experience to their homes, that spark of curiosity ignited the idea for GLAMSQUAD. Launched in New York in 2014, GLAMSQUAD was ahead of its time — blending luxury with convenience.

Today, more than a decade later, GLAMSQUAD has expanded into 15+ cities across the U.S. and employs over 2,000 beauty professionals. The company has completed over one million services and was named the 2018 Best Beauty App, serving high-profile clients including Tiffany & Co., Cartier, and Netflix.`,
    quote: {
      text: "It's not just about the hair, it's about confidence.",
      attribution: 'Giovanni Vaccaro',
    },
  },
}

export const DEFAULT_AUTHOR_SLUG = 'giovanni-vaccaro'

export const getAuthor = (slug) =>
  authors[slug] || authors[DEFAULT_AUTHOR_SLUG]
